import React from "react";

import { 
  Card,
  Typography, 
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { fShortenNumber } from "../../Utils/formatNumber";
import Iconify from "../Dashboard/Iconify";


const RootStyle = styled(Card)(({ theme, bgcolor = "#FFE2E5" }) => ({
  boxShadow: "none",
  textAlign: "center",
  padding: theme.spacing(3, 0),
  color: theme.palette.primary.darker,
  backgroundColor: bgcolor,
  borderRadius: "16px",
}));

const IconWrapperStyle = styled("div")(({ theme, bgcolor = "#FA5A7D" }) => ({
  margin: "auto",
  display: "flex",
  borderRadius: "50%",
  alignItems: "center",
  width: theme.spacing(5),
  height: theme.spacing(5),
  justifyContent: "center",
  marginBottom: theme.spacing(2),
  color: "#fff",
  backgroundColor: bgcolor,
}));

const DashboardCard = ({
  value,
  title,
  bgcolor,
  iconColor,
  theIcon,
  id,
  valueType
}) => {
  return (
    <RootStyle bgcolor={bgcolor} id={id}>
      <IconWrapperStyle bgcolor={iconColor}>
        <Iconify icon={theIcon} width={22} height={22} />
      </IconWrapperStyle>
      <Typography variant="h5" fontWeight={700} fontSize={"25px"}>
        {valueType && valueType==="text"?value:
        fShortenNumber(value)}
      </Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72, fontSize: "12px" }}>
        {title}
      </Typography>
    </RootStyle>
  );
};


export default DashboardCard;